import { ContentSwitcherBySkin } from 'components/Atoms/ContentSwitcherBySkin'
import { LeftPanelAppCSS } from './LeftPanelAppCSS.styled'
import { PoweredByYolorektLogo } from 'components/pages/gamesV3/PoweredByYolorektLogo'
import { YolorektLogo } from 'components/pages/gamesV3/YolorektLogo/YolorektLogo'
import { ProfilePanelHeader } from 'components/pages/gamesV3/Profile'
import { useLayoutV3State } from 'hooks/useLayoutV3State'
import { StaticLeftPanelSection } from 'components/pages/gamesV3/StaticContent.leftPanelSection'
import { PanelSection } from 'components/Molecules/PanelSection'

import { SKINS } from 'constants/skins'
import { PANEL_SECTIONS } from './PanelSectionsDefinition'
import { TopLeftNav } from 'components/pages/gamesV3/TopLeftNav'
import { ReferralsDropDown } from '../ReferralsDropDown'
import { TelegramBotButton } from '../TelegramBotButton'
import { YolTokenButton } from './YoloTokenButton'
import { AchievementButton } from './AchievementButton'
import { useUser } from 'hooks/user/useUser'

const LOGO_BY_SKIN = {
  [SKINS.WSB]: <PoweredByYolorektLogo href='/game' />,
  [SKINS.DEFAULT]: <YolorektLogo href='/game' />,
}

export const LeftPanelApp = ({ children }) => {
  const { isConnected } = useUser('wallet')
  const { hideLeftPanel, isOpenLeftPanel, setOpenLeftPanel } = useLayoutV3State()

  const toggleLeftPanel = () => {
    setOpenLeftPanel(!isOpenLeftPanel)
  }

  return (
    <LeftPanelAppCSS className='left_panel_app'>
      <div className='left_header_space'>
        <ContentSwitcherBySkin noWrapper componentsBySkin={LOGO_BY_SKIN} />
        <TopLeftNav>
          <ReferralsDropDown />
          {isConnected && <AchievementButton />}
          <TelegramBotButton />
          <YolTokenButton />
        </TopLeftNav>
      </div>

      {!hideLeftPanel && (
        <div className='games_panel'>
          <label htmlFor='check' className='togButton' onClick={toggleLeftPanel}></label>
          <input type='checkbox' className='togCheck' id='check' checked={isOpenLeftPanel} />

          <div className='togContent'>
            <ProfilePanelHeader />
            <StaticLeftPanelSection />
            {PANEL_SECTIONS.map((sectionProps, index) => {
              if (sectionProps.forLoggedUsers && !isConnected) return null

              if (sectionProps.showWithSkin) {
                return (
                  <ContentSwitcherBySkin
                    key={`ctSw0${index}`}
                    noWrapper
                    noWarning
                    componentsBySkin={{
                      [sectionProps.showWithSkin]: <PanelSection key={`ctSw1${index}`} {...sectionProps} />,
                    }}
                  />
                )
              }
              return <PanelSection key={`ctSw2${index}`} {...sectionProps} />
            })}
            {children}
          </div>
        </div>
      )}
    </LeftPanelAppCSS>
  )
}
